import React, { useState } from "react";
import Select from "react-select";

const SelectLawyer = ({
  name,
  options,
  className,
  disable = false,
  value,
  defaultValue,
  // selectedOption = "",
  // setSelectOption,
  setField,
}) => {
  const handleChange = (e) => {
    setField(name)(e);

    // if (setSelectOption != undefined) setSelectOption(selectedOption);
  };

  console.log("VALUIE", value);

  const customStyles = {
    input: () => ({
      height: 36,
      border: "0px solid black",
    }),
    control: (base, state) => ({
      ...base,
      border: "1px solid #DDE2E9",
      /*
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid black',
            }*/
    }),
  };

  const findIndex =
    options?.length > 0
      ? options.findIndex((option) => option.label === value)
      : 0;

  return (
    <Select
      styles={customStyles}
      // isDisabled={disable}
      isSearchable={true}
      className={className}
      options={options}
      onChange={handleChange}
      value={options && options[findIndex]}
      // value={value}
    />
  );
};

export default SelectLawyer;
